import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../services/wrapper-http-service';
import { ENV_NAME } from '../../../services/config/config.service';
import { EnvironmentName } from '../../../services';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementsService {
  constructor(private http: WrapperHttpService) {}

  getAnnouncement(): Observable<string> {
    const headers = new Headers({
      'Cache-Control': 'no-store',
    });
    const timestamp = Date.now();

    let fileName: string;
    switch (ENV_NAME) {
      case EnvironmentName.Stage:
        fileName = 'announcements-staging.txt';
        break;
      case EnvironmentName.Dev:
        fileName = 'announcements-dev.txt';
        break;
      case EnvironmentName.Prod:
        fileName = 'announcements-prod.txt';
        break;
      case EnvironmentName.Qa:
        fileName = 'announcements-qa.txt';
        break;
      default:
        fileName = 'announcements.txt';
    }

    return this.http
      .withLoading()
      .get<string>(`https://micrsadfrtconfig1.blob.core.windows.net/$web/${fileName}?timestamp=${timestamp}`, {
        responseType: 'text',
        Headers: headers,
      });
  }
}
